// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".8bed87184e146217430930c8bdb1448d153bad3e.chunk.bundle.js";
};